import type { TeamStatsMember } from './teamStats'
import { type RosterStatus, formatLastActive } from './rosterStatus'

const STATUS_LABEL: Record<RosterStatus, string> = { top: 'TOP', ontrack: 'ON TRACK', stalled: 'STALLED', risk: 'AT RISK' }

const csvEscape = (value: string): string => (/[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value)

export const buildRosterCsv = (members: TeamStatsMember[], statuses: Map<number, RosterStatus>, now: number): string => {
  const header = ['Name', 'Email', 'Sessions', 'Avg score', 'Last active', 'Status', 'Mastered']
  const rows = [...members]
    .sort((a, b) => b.avgScore - a.avgScore)
    .map((m) => [
      [m.firstName, m.lastName].filter(Boolean).join(' ').trim() || m.email,
      m.email,
      String(m.totalSessions),
      m.avgScore.toFixed(1),
      m.lastActiveAt ? `${m.lastActiveAt} (${formatLastActive(m.lastActiveAt, now)})` : 'Never',
      STATUS_LABEL[statuses.get(m.userId) || 'ontrack'],
      String(m.masteredCount),
    ])
  return [header, ...rows].map((row) => row.map(csvEscape).join(',')).join('\n')
}

export const downloadCsv = (csv: string, filename: string): void => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
